import { PaymentPlansApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function usePlansAPI(): PaymentPlansApi {
  return new PaymentPlansApi(apiConfig);
}
